import { motion } from "framer-motion";

const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      ease: "easeOut",
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0,  scale: 0.9 },
  show: { opacity: 1,  scale: 1, transition: { duration: 0.6 } },
};

export const StaggeredContainer = ({ children }) => (
  <motion.div
    variants={containerVariants}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.05 }}
  >
    {children}
  </motion.div>
);

export const StaggeredItem = ({ children }) => (
  <motion.div variants={itemVariants}>{children}</motion.div>
);
